import _isEmpty from 'lodash/isEmpty';
import _isString from 'lodash/isString';
import { isServerSideRendering } from '../../../../../../../../utils/gatsby';
export function getPopupOffset(triggerRef, targetContainerId, isDesktop) {
  if (isServerSideRendering()) {
    return undefined;
  }
  if (_isEmpty(triggerRef) || _isEmpty(targetContainerId) || _isEmpty(triggerRef.current)) {
    return undefined;
  }
  if (!isDesktop) {
    return undefined;
  }
  var current = triggerRef.current;
  var triggerRect = current.getBoundingClientRect();
  var targetContainer = _isString(targetContainerId) ? document.getElementById(targetContainerId) : targetContainerId;
  if (!targetContainer) {
    return undefined;
  }
  var targetContainerRect = targetContainer.getBoundingClientRect();
  var bottomOffset = targetContainerRect.bottom - triggerRect.bottom - 1;
  return [0, bottomOffset];
}